(() => {
  const initCarousel = (root) => {
    if (!root || root.dataset.tiktokCarouselReady === 'true') return;
    root.dataset.tiktokCarouselReady = 'true';

    const track = root.querySelector('[data-tiktok-video-track]');
    const prev = root.querySelector('[data-video-scroll="prev"]');
    const next = root.querySelector('[data-video-scroll="next"]');

    if (!track) return;

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      const hasOverflow = maxScroll > 4;

      root.classList.toggle('is-scrollable', hasOverflow);

      if (prev) {
        prev.hidden = !hasOverflow || track.scrollLeft <= 2;
        prev.disabled = !hasOverflow || track.scrollLeft <= 2;
      }

      if (next) {
        next.hidden = !hasOverflow || track.scrollLeft >= maxScroll;
        next.disabled = !hasOverflow || track.scrollLeft >= maxScroll;
      }
    };

    const scrollOnePage = (direction) => {
      const amount = Math.max(track.clientWidth * 0.82, 260);
      track.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: 'smooth'
      });
    };

    prev?.addEventListener('click', () => scrollOnePage('prev'));
    next?.addEventListener('click', () => scrollOnePage('next'));

    track.addEventListener('scroll', updateControls, { passive: true });

    window.addEventListener('resize', updateControls);

    // Mouse wheel support on desktop: vertical wheel over the carousel
    // becomes horizontal movement when the carousel has overflow.
    track.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaY) > Math.abs(event.deltaX) && track.scrollWidth > track.clientWidth) {
        if (Math.abs(event.deltaY) > 8) {
          track.scrollLeft += event.deltaY;
          event.preventDefault();
        }
      }
    }, { passive: false });

    // Keyboard support when the carousel is focused.
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollOnePage('prev');
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollOnePage('next');
      }
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateControls);
      observer.observe(track);
    }

    updateControls();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tiktok-video-carousel]')) initCarousel(scope);
    scope.querySelectorAll?.('[data-tiktok-video-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
